import Vue from 'vue';
import {
  Button,
  Toast,
  Field,
  List,
  Cell,
  Checkbox,
  Image as VanImage,
  Lazyload,
  Tabs,
  Tab,
  Swipe,
  SwipeItem,
  Popup,
  Dialog,
  PasswordInput,
  Search,
  Sidebar,
  SidebarItem
} from 'vant';

Vue.use(Button);
Vue.use(Toast);
Vue.prototype.$Toast = Toast;
Vue.use(Field);
Vue.use(List);
Vue.use(Cell);
Vue.use(Checkbox);
Vue.use(VanImage);
Vue.use(Lazyload, {
  lazyComponent: true,
});
Vue.use(Tabs);
Vue.use(Tab);
Vue.use(Swipe);
Vue.use(SwipeItem);
Vue.use(Popup);
Vue.use(Dialog);
Vue.use(PasswordInput);
Vue.use(Search);
Vue.use(Sidebar);
Vue.use(SidebarItem);